const TRANSLATION_BUSINESS_TYPES = new Set([
  'sports',
  'padel_court',
  'restaurant',
  'clinic',
  'studio',
  'member_club',
  'gym',
]);

export function normalizeTranslationBusinessType(value: unknown) {
  return typeof value === 'string' && TRANSLATION_BUSINESS_TYPES.has(value)
    ? value
    : null;
}
